<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13qucvq/tc-custom/9781526760234.jpg?1705206816757" alt="This image is the cover for the book Marching, Fighting, Dying"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Marching, Fighting, Dying
      </h1>
      <p class="bookDescription body article font2">
        <p>Gareth Glover, who has established a reputation as a leading authority on the Napoleonic Wars, uses letters sent home from the Peninsular War by British soldiers to give a candid account of what it was like to serve in the army during the long campaign against the French. The vivid excerpts, which are set in their historical context by the author’s expert commentary, are largely drawn from the correspondence of the other ranks, and they fully explore the everyday experience of these men through their own words.  Only extracts from letters written during the campaigns are quoted – journals written much later for publication are discounted – so a true picture of life in the army at war comes out directly, as it was perceived at the time. Every aspect of the soldiers’ experience is covered, from the fatigue and discomfort of existence on military service to the reality of combat and their feelings when a comrade was wounded or killed. The letters reveal so much about their attitude to the enemy, civilians and the men who served alongside them.  Since this was the first war in history where regular postal services operated – and since a rising number of soldiers were able to read and write – their letters offer us an insight into men at war that has never been recorded before.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gareth Glover
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?52640322